import React, { Component } from 'react';
import Drawer from '..';

class DesktopDrawer extends Component {
  state = {
    currentDrawerKey: '',
  };

  toggleDrawer = menuKey => {
    if (this.state.currentDrawerKey === menuKey) {
      this.setState({ currentDrawerKey: '' });
    } else {
      this.setState({ currentDrawerKey: menuKey });
    }
  };

  render() {
    const productsOpenState = this.state.currentDrawerKey === 'Products';
    const helpOpenState = this.state.currentDrawerKey === 'Help';
    return (
      <>
        <Drawer
          drawerKey="Products"
          isDrawerOpen={productsOpenState}
          parentToggleDrawer={this.toggleDrawer}
        />
        <Drawer
          drawerKey="Help"
          isDrawerOpen={helpOpenState}
          parentToggleDrawer={this.toggleDrawer}
        />
      </>
    );
  }
}

export default DesktopDrawer;
